import styled from "styled-components";
import {Button, Form} from "antd";

const LoginForm = styled(Form)`
  margin: 30% 0 0 0;

  padding: 0 40px 40px 40px;
  background: #fff;
  border-radius: 35px;
  border-width: 1px;
  border-style: solid;
  border-color: linear-gradient(90deg, #169F8A -1.09%, #07456F 100%);

  & * {
    font-family: "Montserrat", sans-serif;
  }

  .ant-form-item-explain-error {
    font-size: 12px !important; /* re-write base styles for ant error */
  }
`;

const LogoElement = styled.img`
  width: 200px;
  margin: 32px 0 70px 0;
`;

const SubmitButton = styled(Button)`
  background: linear-gradient(90deg, #169F8A -1.09%, #07456F 100%);
  width: 100%;
  border-radius: 2px;
  font-size: 16px;
  font-weight: 300;
  transition: .1ms;

  &:hover {
    background: linear-gradient(90deg, #07456F -1.09%, #169F8A 100%);
    font-weight: 400;
    transition: .1ms;
  }

`;

const ForgotPasswordButton = styled(Button)`
  color: #000000A6 !important;
  font-weight: 200;
  font-size: 14px;
  transition: .1ms;

  &:hover {
    font-weight: 400;
    transition: .1ms;
  }
`;

export {LoginForm, LogoElement, SubmitButton, ForgotPasswordButton};